<template>
  <section id="contact">
    <div class="container">
      <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
        <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
          <path
            d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
        </symbol>
        <symbol id="info-fill" fill="currentColor" viewBox="0 0 16 16">
          <path
            d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
        </symbol>
        <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
          <path
            d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
        </symbol>
      </svg>
      <div class="row">
        <div class="col-xl-8 col-lg-8 col-md-8 col-xm-12 col-sm-12">
          <div class="card">
            <div class="card-header">Faites vos paiements</div>
            <div class="card-body">
              <div class="col-12">
                <Form ref="paiementForm" @submit="payer" :validation-schema="paiementSchema">
                  <div id="stepper" class="bs-stepper">
                    <div class="bs-stepper-header" disabled>
                      <div class="step" data-target="#step-1">
                        <button class="btn btn-success step-trigger" disabled>
                          <span class="bs-stepper-circle">1</span>
                          <span class="bs-stepper-label">Information</span>
                        </button>
                      </div>
                      <div class="line"></div>
                      <div class="step" data-target="#step-2">
                        <button class="step-trigger" disabled>
                          <span class="bs-stepper-circle">2</span>
                          <span class="bs-stepper-label">Facture(s) impayée(s)</span>
                        </button>
                      </div>
                      <div class="line"></div>
                      <div class="step" data-target="#step-3" disabled>
                        <button class="step-trigger" disabled>
                          <span class="bs-stepper-circle">3</span>
                          <span class="bs-stepper-label">Paiement</span>
                        </button>
                      </div>
                    </div>

                    <div class="bs-stepper-content">
                      <div id="step-1" class="content">
                        <h4>
                          Veuillez saisir votre Numéro Personnel d'Identification (NPI)
                        </h4>
                        <div class="row">
                          <div class="col-md-12">
                            <label class="d-block text-black fw-semibold mb-10">
                              Saississez votre numéro NPI
                              (Ex: 000000000)
                            </label>
                            <Field name="reference" type="text" v-model="reference" class="form-control" />
                            <ErrorMessage name="reference" class="text-danger" />
                          </div>
                        </div>
                        <div class="offset-9 mt-10 col-md-3 text-end">
                          <button @click="nextStep(1)" class="btn btn-success" type="button" v-show="valideEtape1">
                            Suivant
                          </button>

                          <button class="btn btn-success" type="button" v-show="!valideEtape1" disabled>
                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span class="visually-hidden">Loading...</span>
                          </button>
                        </div>
                      </div>
                      <div id="step-2" class="content">
                        <h3>Facture(s) impayée(s)</h3>
                        <div class="row" v-show="affiche">
                          <div class="col-12">
                            <div class="alert alert-success d-flex align-items-center" role="alert" :style="alertStyle">
                              <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img"
                                aria-label="Success:">
                                <use xlink:href="#check-circle-fill" />
                              </svg>
                              <div>
                                Bravo !!! Vous n'avez aucun impayé à cette date
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between">
                              <h6 class="card-title fw-bold mb-0">

                              </h6>
                              <div
                                class="card-select mt-10 mt-sm-0 mb-10 mb-sm-0 d-flex align-items-center ps-10 pe-10 pt-5 pb-5">
                                <span class="fw-medium text-muted me-8">TOTAL IMPAYE : {{ somRedevance }}</span>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="row" v-for="(card, index) in cards" :key="index">
                                <h6 class="card-title fw-bold mb-0">
                                  {{ card.code }}
                                </h6>
                                <div class="col-12">
                                  <div class="container py-4">
                                    <div class="row" style="justify-content: space-between">
                                      <div class="col-sm-12 col-md-6 col-xl-6 col-xxl-6 fs-10"
                                        v-for="(facture, index2) in card.factures" :key="index2">
                                        <Facture :reference="facture.reference" :month="facture.month"
                                          :cost="facture.cost" @select="onCardSelect(index, index2, $event)" />
                                      </div>

                                    </div>

                                    <p class="mt-4">
                                      Montant à payer : {{ aPayer }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="offset-6 mt-10 col-6 text-end">
                            <button class="btn btn-secondary" @click="previousStep(1)" type="button">
                              Precédent
                            </button>
                            <button class="btn btn-success" type="button" style="margin-left: 0.5em"
                              @click="nextStep(2)" v-show="valideEtape2">
                              Suivant
                            </button>
                            <button class="btn btn-success" type="button" v-show="!valideEtape2" disabled>
                              <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                              <span class="visually-hidden">Loading...</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div id="step-3" class="content">
                        <h3>Mode de paiement</h3>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="row mt-10">
                              <div class="col-md-6">
                                <label for="mois" class="form-label fw-medium text-black">
                                  Référence des factures
                                </label>
                                <Field name="mois" :disabled="true" v-model="mois"
                                  class="form-control shadow-none fs-md-15 text-black" />
                                <ErrorMessage name="mois" class="text-danger" />
                              </div>
                              <div class="col-md-6">
                                <label for="montant" class="form-label fw-medium text-black">
                                  Montant
                                </label>
                                <Field name="montant" v-model="aPayer" :disabled="true"
                                  class="form-control shadow-none fs-md-15 text-black" />
                                <ErrorMessage name="montant" class="text-danger" />
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="row mt-10">
                              <div class="text-end">
                                <button class="btn btn-warning" type="button" @click="previousStep">
                                  Precédent
                                </button>
                                <button class="btn btn-success" type="submit" style="margin-left: 0.5em"
                                  v-show="valideEtape3">
                                  Payer
                                </button>
                                <button class="btn btn-success" type="button" v-show="!valideEtape3" disabled>
                                  <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                  <span class="visually-hidden">Chargement...</span>
                                </button>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-4 col-lg-4 col-md-4 col-xm-12 col-sm-12">
          <div class="card mb-3">
            <div class="card-header bg-light">
              <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Info:">
                <use xlink:href="#info-fill" />
              </svg>
              A propos E-Paie ANaGeM
            </div>
            <div class="card-body bg-white">
              <h6 class="card-title">Ce dont vous avez besoin</h6>
              <ol class="list-group list-group-numbered bg-light">
                <li class="list-group-item d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">Durée de traitement</div>
                  </div>
                  <span class="badge bg-primary rounded-pill">3 min</span>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">Le nécessaire</div>
                    <p>- Votre numéro NPI (C'EST MOI)</p>
                    <p>- Un téléphone portable</p>
                    <p>- Une connexion internet</p>
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">3 étapes clés</div>
                    <p>- Renseignez NPI</p>
                    <p>- Consultez vos impayés</p>
                    <p>- Sélectionnez les factures à payer</p>
                    <p>- Procédez au paiement en ligne</p>
                  </div>
                </li>
                <li class="list-group-item d-flex justify-content-between align-items-start">
                  <div class="ms-2 me-auto">
                    <div class="fw-bold">ANaGeM</div>
                    <p>RDV à la ANaGeM en cas de problème pour être rapidement pris
                    en charge par un agent.</p>
                    <p>Faites un(e) réclammation/suggestion/message sur notre plateforme </p>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import {
  ref,
  onMounted,
  watch,
  reactive,
  computed,
  toRef,
  onBeforeUnmount,
} from "vue";
import Stepper from "bs-stepper";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import axios from "axios";
import {
  error,
  nomBreMoisAnneeEntame,
  recuperLesMoisDu,
  success,
  getMonthsWithinRange,
  getUrlApiForFiles,
  retraitChargement,
} from "@/utils/utils";
import { useRouter } from "vue-router";
import router from "@/router";
import {
  openKkiapayWidget,
  addKkiapayListener,
  removeKkiapayListener,
} from "kkiapay";
import { KKIAPAY } from "@/models/KKIAPAY";
import ApiService from "@/services/ApiService";
import Swal from "sweetalert2";
import Facture from "./Facture.vue";

export default {
  name: "FormulairePaiement",
  components: {
    Form,
    Field,
    ErrorMessage,
    Facture,
  },
  setup() {
    const cards = ref();
    const selectedCards = ref([]);
    const selectedCost = ref([]);
    const selectedReference = ref([]);
    const valideEtape1 = ref(true);
    const valideEtape2 = ref(true);
    const valideEtape3 = ref(true);
    const stepper = ref(null);
    const reference = ref("");
    const paiementSchema = Yup.object().shape({
     // reference: Yup.string().notRequired(),
      reference:Yup.string()
        .matches(/^\d{10}$/, "NPI doit contenir exactement 10 chiffres.")
        .required("NPI est obligatoire."),
      mois: Yup.string().notRequired(),
      //  mode: Yup.number().notRequired(),
      montant: Yup.number().notRequired(),
    });
    const contrat = ref(null);
    const montant = ref(0);
    const mois = ref(0);
    var check = reactive({
      typeError: "RAS",
      idTransaction: 0,
    });

    async function successHandler(response, values, { resetForm }) {
      check.typeError = "SUCCESS";
      check.idTransaction = response.transactionId;
      values["idTransaction"] = check.idTransaction;
      values["check"] = check;
      // Bloc de code à exécuter lorsque le paiement est un succès
      console.log("Checker ==> ", values);
      if (check.typeError === "SUCCESS") {
        await finishStep(values, { resetForm });
      } else {
        check.typeError = "RAS";
        check.idTransaction = 0;
      }
      // Retourne les données après l'exécution
      return { check, response };
    }

    const aPayer = ref(0);

    const onCardSelect = (index, index2, isSelected) => {
      aPayer.value = 0;
      const cont = cards.value[index];

      const lid = (cont.factures[index2]).id;

      (cont.factures[index2]).etat = ((cont.factures[index2]).etat) === true ? false : true;

      const etat = (cont.factures[index2]).etat;
      const reference = (cont.factures[index2]).reference;

      if(etat) {
        selectedCards.value.push(lid);
        selectedReference.value.push(reference);
      } else {
        //Retirerer 
        selectedCards.value = selectedCards.value.filter(
          (ref) => ref !== lid
        );
        selectedReference.value = selectedReference.value.filter(
          (ref) => ref !== reference
        );
      }


      //const montant = cards.value[index].cost;
      // if (isSelected) {
      //   selectedCards.value.push(lid);
      //   selectedReference.value.push(reference);
      // } else {
      //   selectedCards.value = selectedCards.value.filter(
      //     (ref) => ref !== lid
      //   );
      //   selectedReference.value = selectedReference.value.filter(
      //     (ref) => ref !== reference
      //   );
      // }
      //Chargement des montant sélectionné dans un tableau

      //Calcule du montant à payer
      if (selectedCards.value.length > 0) {
        for(const contrat of cards.value){
          for(const facture of contrat.factures){
            if(selectedCards.value.includes(facture.id)){
              aPayer.value += parseFloat(facture.cost);
            }
          }
        }
      } else {
        aPayer.value = 0;
      }
      if (selectedReference.value.length > 0) {
        mois.value = selectedReference.value.join(" , ")
      }
    };



    async function failHandler(response, values, { resetForm }) {
      check.typeError = "ECHOUE";
      check.idTransaction = response.transactionId;
      check.typeError = "RAS";
      check.idTransaction = response.transactionId;

      values["idTransaction"] = check.idTransaction;
      values["check"] = check;
      // Bloc de code à exécuter lorsque le paiement est un succès
      if (check.typeError === "RAS") {
        // Appel de la fonction addAbonnement et attente de son exécution
        // await finishStep(values, { resetForm });
      }
      // Retourne les données après l'exécution
      return { check, response };
    }
    const months = [
      "Janvier",
      "Février",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Août",
      "Septembre",
      "Octobre",
      "Novembre",
      "Décembre",
    ];

    const payer = async (values, { resetForm }) => {

      valideEtape1.value = false;
      valideEtape2.value = false;
      valideEtape3.value = false;
      values["reference"] = reference?.value ?? null;
      values["montant"] = aPayer?.value ?? null;
      values["mois"] = selectedReference.value ?? null;
      values["mode"] = 2;
      values["factures"] = selectedCards.value ?? "";

      if (!values.reference) {
        error("Veuillez saisir une référence valide.");
        valideEtape3.value = true;
        return;
      }
      if (!values.montant) {
        error(
          "Veuillez selectionner des factures valides."
        );
        valideEtape3.value = true;
        return;
      }
      if (!values.mode) {
        error("Veuillez choisir un mode de paiement valide.");
        valideEtape3.value = true;
        return;
      }

      console.log("Value de paiement = = > ", values);
      if (values.mode == 1) {
        try {
          const result = await Swal.fire({
            text:
              "Vous êtes sur le point de faire un paiement d'une somme de " +
              values.montant +
              " F CFA",
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-suucess",
              cancelButton: "btn btn-danger",
            },
          });

          if (result.isConfirmed) {
            values["check"] = KKIAPAY.check;
            await finishStep(values);
          }
          valideEtape3.value = true;
        } catch (error) {
          //
          valideEtape3.value = true;
        }
      }
      if (values.mode == 2) {
        try {
          const result = await Swal.fire({
            html:
              `Vous êtes sur le point de faire un paiement d'une somme de <b style="color:#dc3545;"> ${values.montant} </b>F CFA`,
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-danger",
            },
          });
          //await finishStep(values, { resetForm });
          if (result.isConfirmed) {
            KKIAPAY.kkia(values.montant);
            // Écoute des événements
            addKkiapayListener("failed", (event) => {
              failHandler(event, values, { resetForm });
              // Actions à prendre après l'échec
            });

            addKkiapayListener("success", (event) => {
              successHandler(event, values, { resetForm });
              // Actions à prendre après le succès
              console.log("Opération réussie.");
            });

            const checkRef = toRef(check);
            let resolved = false;

            // Vérification en continu de l'état
            const intervalId = setInterval(() => {
              if (!resolved && checkRef.value.typeError !== "RAS") {
                clearInterval(intervalId);
                resolved = true;
                // Actions à prendre après détection d'une erreur
              }
            }, 500);
          }
        } catch (error) {
          //
          valideEtape3.value = true;
        }
      }
    };

    const information = async (referen = "") => {
      try {
        arrieres.value = [];
        const response = await axios.get(`factures/ref/${referen}`);
        const donnees = response.data?.data;

        if (donnees.length > 0) {
          cards.value = donnees.map((contrat) => (
            {
              contratId: contrat.id,
              reference: contrat.reference,
              marchand: contrat.nomMarchand,
              code: contrat.codePlace,
              factures: contrat.factures.map((fact) => ({
                id: fact.id,
                reference: (fact.reference).toString(),
                date: fact.date_facture,
                cost: fact.caution ? parseFloat(fact.caution.montantCaution.toString()) : parseFloat(fact.montant_facture.toString()),
                place: fact.codePlace,
                etat:false,
                month: months[fact.mois] + " " + fact.annee,
                loyer: fact.loyer,
              }))
            }));
        }
        valideEtape1.value = true;
      } catch (err) {
        error("Oups, il y a un problème.");
        valideEtape1.value = true;
      }
    };
    const somRedevance = ref(0);
    const loyer = ref(0);
    const choix = ref();
    const contrats = ref([])
    const arrieres = ref([]);

    const nombreTotalUsager = ref(0);

    const nextStep = async (stepp = 0) => {
      if (stepp === 1) {
        valideEtape1.value = false;
        arrieres.value = [];
        if (!reference.value) {
          error("Veuillez d’abord saisir votre numéro NPI valide");
          valideEtape1.value = true;
          return;
        } else {
          await information(reference.value);
          console.log("LES CARD S ===>", cards.value);
          if (cards.value && cards.value.length > 0) {
            somRedevance.value = 0;
            for(const contrat of cards.value){
              for(const facture of contrat.factures){
                somRedevance.value += parseFloat(facture.cost);
              }
            }
          } else {
            error("Aucun droit de place trouvé pour cette référence");
            somRedevance.value = 0;
            return;
          }
        }
      }
      if (stepp === 2) {
        if (cards.value.length < 1) {
          valideEtape1.value = false;
          error("Vous n'avez aucune facture en attente");
          return;
        }
      }
      stepper.value.next();
    };

    const previousStep = () => {
      stepper.value.previous();
    };

    const choixMode = (mode = "") => {
      choix.value = mode;
    };


    const openAndPrint = (url = "") => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    function openNewWindow(data) {
      openAndPrint(getUrlApiForFiles("Recu", data + ".pdf"));
    }

    const finishStep = async (values, { resetForm }) => {
      try {
        const response = await axios.post("/paiement", values);
        if (response.data.code == 201) {
          const data = response.data;
          console.log("DTATA ====> ", data)
          success(response.data.message);
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "LandingPage" });
            const maFonction = async () => {
              const result = await Swal.fire({
                html: `<div>Cliquer sur le bouton Aperçu ci-dessous pour avoir un aperçu de votre document</div>`,
                icon: "success",
                buttonsStyling: true,
                confirmButtonText: "Aperçu",
                showCancelButton: false,
                cancelButtonText: `Fermer`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                heightAuto: false,
                customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-warning",
                },
              });

              if (result.isConfirmed) {
                openNewWindow(data.data.reference);
              }
            };
            // Utiliser setTimeout pour exécuter la fonction après la durée spécifiée
            setTimeout(maFonction, 3000);
          } else {
            error(data.message);
          }
        }
        valideEtape1.value = true;
      } catch (error) {
        console.error(error);
        valideEtape1.value = true;
      }
      // Ajoutez ici la logique de traitement après le paiement
    };
    onMounted(() => {
      retraitChargement();
      stepper.value = new Stepper(document.querySelector("#stepper"), {
        linear: false,
        animation: true,
      });
    });


    const isFading = ref(false);
    let intervalId = null;
    const affiche = ref(false);

    // Style réactif de l'alerte
    const alertStyle = computed(() => ({
      opacity: isFading.value ? 0 : 1,
      transition: "opacity 0.5s ease",
    }));

    // Démarrer le clignotement
    const startBlinking = () => {
      intervalId = setInterval(() => {
        isFading.value = !isFading.value;
      }, 1000); // Clignote toutes les 1000 ms
    };

    // Nettoyer l'effet à la destruction
    const stopBlinking = () => {
      clearInterval(intervalId);
    };

    // Démarrer automatiquement à l'initialisation
    onMounted(() => {
      retraitChargement();
      startBlinking();
    });

    // Nettoyer lors de la destruction du composant
    onBeforeUnmount(() => {
      stopBlinking();
    });

    return {
      reference,
      paiementSchema,
      nextStep,
      previousStep,
      finishStep,
      somRedevance,
      arrieres,
      mois,
      payer,
      choix,
      loyer,
      affiche,
      montant,
      months,
      choixMode,
      contrat,
      cards,
      selectedCards,
      selectedCost,
      aPayer,
      alertStyle,
      valideEtape1,
      valideEtape2,
      valideEtape3,
      onCardSelect,
    };
  },
};
</script>

<style>
/* Ajoutez vos styles personnalisés ici si nécessaire */

p {
  margin: 0 !important;
}
</style>